const dataURIToBlob = (dataURI: any): any => {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0];
  const ia = new Uint8Array(byteString.length);

  // @ts-ignore
  [...Array(byteString.length).keys()].forEach(i => {
    ia[i] = byteString.charCodeAt(i);
  });

  return new Blob([ia], { type: mimeString });
};

export default dataURIToBlob;
